import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.blue.light25,
    color: theme.palette.secondary.main,
    paddingBottom: theme.spacing(10),
  },
  contentWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  headline: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(4),
  },
}))

export default useStyles
